import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { flexCenter, palette, flexColumn } from '../../constants/styles';
import Icon from './Icon';
import Text from './Text';

const StyledFullscreenSection = styled.div`
  height: 90vh;
  background-color: white;
  ${flexCenter}
  ${({ alignTop }) =>
    alignTop &&
    css`
      height: 90vh;
    `}
`;

const StyledTeaser = styled.div`
  position: absolute;
  background-color: white;
  bottom: 0px;
  height: 15vh;
  ${({ small }) =>
    small &&
    css`
      height: 8vh;
    `}
  width: 100%;
  cursor: pointer;
  &:hover {
    background-color: ${palette.terciaryColorShy}22;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.05);
  }
  ${flexCenter}
  z-index: 200000;
`;

const StyledContent = styled.div`
  ${flexColumn}
  justify-content: center;
  align-items: center;
  margin: 20px;
  ${({ alignTop }) =>
    alignTop &&
    css`
      height: 70vh;
    `}
`;

const StyledContentWrapper = styled.div`
  max-width: 540px;
  ${({ styles }) => styles}
  ${({ alignTop }) =>
    alignTop &&
    css`
      height: 70vh;
    `}
`;

const StyledTeaserText = css`
  width: 200px;
  text-align: center;
`;

const FullscreenSection = ({
  identifier,
  children,
  styles,
  className,
  showTeaser,
  teaserText,
  teaserFunction,
  alignTop,
  smallTeaser,
}) => (
  <StyledFullscreenSection alignTop={alignTop} data-anchor={identifier} className={className}>
    <StyledContent alignTop={alignTop}>
      <StyledContentWrapper alignTop={alignTop} styles={styles}>
        {children}
      </StyledContentWrapper>
    </StyledContent>
    {showTeaser && (
      <StyledTeaser
        small={smallTeaser}
        onClick={() => {
          teaserFunction();
        }}
      >
        <Icon
          icon="arrowBack"
          color={palette.secondaryColor}
          size={25}
          style={{ margin: '0 0.3rem 0 0.3rem', transform: 'rotate(-90deg)', cursor: 'pointer' }}
        />
        <Text type={smallTeaser ? 'body1' : 'body2'} bold styles={StyledTeaserText}>
          {teaserText}
        </Text>
        <Icon
          icon="arrowBack"
          color={palette.secondaryColor}
          size={25}
          style={{ margin: '0 0.3rem 0 0.3rem', transform: 'rotate(-90deg)', cursor: 'pointer' }}
        />
      </StyledTeaser>
    )}
  </StyledFullscreenSection>
);

FullscreenSection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
  styles: PropTypes.array,
  className: PropTypes.string,
  showTeaser: PropTypes.bool,
  teaserText: PropTypes.string,
  teaserFunction: PropTypes.func,
};

FullscreenSection.defaultProps = {
  styles: [],
  className: 'section',
  showTeaser: false,
  teaserText: '',
  teaserFunction: () => {},
};

export default FullscreenSection;
